import React from "react"

import "./Amenities.scss"

const Amenities = (props) => {
  return (
    <div className="amenities-section">
      <div className="amenities-section__text">
        { props.acf.location &&
          <>
            <div className="amenities-section__text__heading">Location:</div>
            <div className="amenities-section__text__sub-text">
              {props.acf.location}
            </div>
          </>
        }
        { props.acf.inside &&
          <div className="amenities-section__text__inside">
            <div className="amenities-section__text__heading">Inside</div>
            <div className="amenities-section__text__list">
              <ul>
                { props.acf.inside.map((item, index) => {
                  return (
                    <li key={index}>{item.text}</li>
                  )
                })}
              </ul>
            </div>
          </div>
        }
        { props.acf.outside && 
          <div className="amenities-section__text__outdoor">
            <div className="amenities-section__text__heading">Outside</div>
            <div className="amenities-section__text__list">
              <ul>
                { props.acf.outside.map((item, index) => {
                  return (
                    <li key={index}>{item.text}</li>
                  )
                })}
              </ul>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default Amenities
